import React from 'react';

import Spinner from 'click-controls/controls/spinner';

export interface IProps {
  className?: string;
  footer: React.ReactNode;
  isSaving?: boolean;
}

const DialogFooter: React.FC<IProps> = ({ className: pClassName, footer, isSaving }) => {
  const className = React.useMemo<string>(() => {
    return ['flex gap-4 pt-4 shrink-0 justify-end'].addNotEmpty(pClassName).toClassNames();
  }, [pClassName]);

  const content = isSaving ? <Spinner /> : footer;

  return <div className={className}>{content}</div>;
};

export default DialogFooter;
